import { lazy, Suspense } from 'react';
import { Outlet } from 'react-router-dom';
// auth
import { AuthGuard } from 'src/auth/guard';
// layouts
import DashboardLayout from 'src/layouts/dashboard';
// components
import { LoadingScreen } from 'src/components/loading-screen';

// ----------------------------------------------------------------------

const Settings = lazy(() => import('src/pages/dashboard/Settings'));

const IndexPage = lazy(() => import('src/pages/dashboard/welcome'));

const Cotizacion = lazy(() => import('src/pages/dashboard/cotizacion'));

const Orden = lazy(() => import('src/pages/dashboard/orden'));

const Cliente = lazy(() => import('src/pages/dashboard/cliente'));

const Rubro = lazy(() => import('src/pages/dashboard/rubro'));

const Transporte = lazy(() => import('src/pages/dashboard/transporte'));

const Contacto = lazy(() => import('src/pages/dashboard/contacto'));

const MatrizProducto = lazy(() => import('src/pages/dashboard/matrizProducto'));
const Producto = lazy(() => import('src/pages/dashboard/producto'));
const Matriz = lazy(() => import('src/pages/dashboard/matriz'));

const TipoProducto = lazy(() => import('src/pages/dashboard/tipoProducto'));

const Compuesto = lazy(() => import('src/pages/dashboard/compuesto'));

const FormulacionCompuesto = lazy(
  () => import('src/pages/dashboard/formulacionCompuesto')
);

const Facturacion = lazy(() => import('src/pages/dashboard/facturacion'));

const Remito = lazy(() => import('src/pages/dashboard/remito'));

const Moneda = lazy(() => import('src/pages/dashboard/moneda'));

const TipoComprobante = lazy(
  () => import('src/pages/dashboard/tipoComprobante')
);

const PuntoDeVenta = lazy(() => import('src/pages/dashboard/puntoDeVenta'));

const SistemaPtoVenta = lazy(
  () => import('src/pages/dashboard/sistemaPtoVenta')
);

const CondicionIva = lazy(() => import('src/pages/dashboard/condicionIva'));

const Actividad = lazy(() => import('src/pages/dashboard/actividad'));

const Proveedor = lazy(() => import('src/pages/dashboard/proveedor'));

const Insumo = lazy(() => import('src/pages/dashboard/insumo'));

const InsumoProveedorStock = lazy(
  () => import('src/pages/dashboard/insumoProveedorStock')
);

const InsumoProveedor = lazy(
  () => import('src/pages/dashboard/insumoProveedor')
);

const TipoInsumo = lazy(() => import('src/pages/dashboard/tipoInsumo'));

const KPIs = lazy(() => import('src/pages/dashboard/kPIs'));

const ParametrosCRM = lazy(() => import('src/pages/dashboard/parametrosCRM'));

const ParametrosProduccion = lazy(
  () => import('src/pages/dashboard/parametrosProduccion')
);
const ParametrosCompras = lazy(
  () => import('src/pages/dashboard/parametrosCompras')
);
const ParametrosFacturacion = lazy(
  () => import('src/pages/dashboard/parametrosFacturacion')
);
const ParametrosProductos = lazy(
  () => import('src/pages/dashboard/parametrosProductos')
);

const Proyecto = lazy(() => import('src/pages/dashboard/proyecto'));
const Compras = lazy(() => import('src/pages/dashboard/compras'));
const Recibo = lazy(() => import('src/pages/dashboard/recibo'));

const ProductoStock = lazy(() => import('src/pages/dashboard/productoStock'));
const Certificado = lazy(() => import('src/pages/dashboard/certificado'));

// ----------------------------------------------------------------------

export const dashboardRoutes = [
  {
    path: 'dashboard',
    element: (
      <AuthGuard>
        <DashboardLayout>
          <Suspense fallback={<LoadingScreen />}>
            <Outlet />
          </Suspense>
        </DashboardLayout>
      </AuthGuard>
    ),
    children: [
      { element: <IndexPage />, index: true },
      { path: 'settings/:tab?', element: <Settings /> },

      {
        path: 'CRM',
        children: [
          { path: 'Cliente', element: <Cliente /> },

          { path: 'Proveedor', element: <Proveedor /> },

          { path: 'Contacto', element: <Contacto /> },
          { path: 'Parametros', element: <ParametrosCRM /> },
        ],
      },
      {
        path: 'Ventas',
        children: [
          { path: 'Cotizacion', element: <Cotizacion /> },

          { path: 'Cliente', element: <Cliente /> },

          { path: 'Rubro', element: <Rubro /> },

          { path: 'Transporte', element: <Transporte /> },

          { path: 'Contacto', element: <Contacto /> },
        ],
      },
      {
        path: 'Produccion',
        children: [
          { path: 'Orden', element: <Orden /> },
          { path: 'Proyecto', element: <Proyecto /> },
          { path: 'Parametros', element: <ParametrosProduccion /> },
        ],
      },
      {
        path: 'Compras',
        children: [
          { path: 'Compras', element: <Compras /> },

          { path: 'Insumo', element: <Insumo /> },

          { path: 'InsumoProveedorStock', element: <InsumoProveedorStock /> },
          { path: 'Certificado', element: <Certificado /> },

          { path: 'InsumoProveedor', element: <InsumoProveedor /> },
          { path: 'TipoInsumo', element: <TipoInsumo /> },
          { path: 'Parametros', element: <ParametrosCompras /> },
        ],
      },

      {
        path: 'Facturacion',
        children: [
          { path: 'Facturacion', element: <Facturacion /> },
          { path: 'Recibo', element: <Recibo /> },

          { path: 'Remito', element: <Remito /> },

          { path: 'Moneda', element: <Moneda /> },

          { path: 'TipoComprobante', element: <TipoComprobante /> },

          { path: 'PuntoDeVenta', element: <PuntoDeVenta /> },

          { path: 'SistemaPtoVenta', element: <SistemaPtoVenta /> },

          { path: 'CondicionIva', element: <CondicionIva /> },

          { path: 'Actividad', element: <Actividad /> },
          { path: 'Parametros', element: <ParametrosFacturacion /> },
        ],
      },

      {
        path: 'Productos',
        children: [
          { path: 'MatrizProducto', element: <MatrizProducto /> },

          { path: 'Producto', element: <Producto /> },

          { path: 'Matriz', element: <Matriz /> },

          { path: 'TipoProducto', element: <TipoProducto /> },

          { path: 'Compuesto', element: <Compuesto /> },

          { path: 'FormulacionCompuesto', element: <FormulacionCompuesto /> },

          { path: 'ProductoStock', element: <ProductoStock /> },

          { path: 'Parametros', element: <ParametrosProductos /> },
        ],
      },

      { path: 'KPIs', element: <KPIs /> },
    ],
  },
];
